import EnableContainer from './EnabledContainer';
import { IEnableSelProps } from './types';
import WarningIcon from '@mui/icons-material/Warning';
import DoneIcon from '@mui/icons-material/Done';

const EnableSelector = ({IsEnabled, truthfulLabel, falseLabel}: IEnableSelProps) => {
  if (IsEnabled){
    return <EnableContainer label={truthfulLabel} color={'#0ACD19'}
      icon={<DoneIcon />}/>;
  }
  return <EnableContainer label={falseLabel} color={'#ff5722'}
    icon={<WarningIcon />}/>;
};

export default EnableSelector;